export default "__VITE_ASSET__DFh0kDRr__"